import { cn } from "@/lib/utils";

/**
 * Divider for a full-width page band: a hairline that fades out at both ends
 * instead of running hard across the viewport, so band edges read as part of
 * the background. The parent must be position: relative.
 */
export const SoftRule = ({
  side = "top",
  className,
}: {
  side?: "top" | "bottom";
  className?: string;
}) => (
  <div
    aria-hidden="true"
    className={cn(
      "pointer-events-none absolute inset-x-0 h-px bg-gradient-to-r from-transparent via-foreground/15 to-transparent",
      side === "top" ? "top-0" : "bottom-0",
      className
    )}
  />
);

export default SoftRule;
